import React from 'react';

import { Box, CircularProgress, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { GridOverlay } from '@mui/x-data-grid';
import CancelPresentationIcon from '@mui/icons-material/CancelPresentation';
import { L10nHTML } from '@uplift/hooks';

import { Loader } from '../Loader';

const useOverlayStyles = makeStyles()(theme => ({
  root: {
  },
  icon: {
    fontSize: '64px',
    color: theme.palette.grey[300],
    marginBottom: theme.spacing(3),
  },
  title: {
    color: theme.palette.text.secondary,
  },
  subtitleContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gridGap: '1rem',
    marginTop: '-1rem',
  },
  subtitle: {
    whiteSpace: 'pre-line',
    lineHeight: '2.5rem',
    textAlign: 'center',
    '& a': {
      color: theme.palette.text.primary,
    },
  }
}));


export type OverlayProps = {
  message?: string | React.ReactNode;
  icon?: React.ReactNode;
  subtitle?: string;
  className?: string;
  button?: React.ReactNode;
};


export const NoItemsOverlayBody: React.VFC<OverlayProps> = ({
  icon = <CancelPresentationIcon fontSize="inherit" />,
  message = 'No items',
  subtitle = '',
  className,
  button,
}) => {
  const { classes } = useOverlayStyles();

  return (
    <Box p={4} display="flex" alignItems="center" justifyContent="center" flexDirection="column" className={className}>
      {icon && (
        <Box className={classes.icon}>
          {icon}
        </Box>
      )}
      {subtitle ? (
        <Box className={classes.subtitleContainer}>
          <Typography variant="h6" className={classes.title}>{message}</Typography>
          <L10nHTML className={classes.subtitle} variant="body1">{subtitle}</L10nHTML>
        </Box>
      ) : (
        <Typography variant="h6" className={classes.title}>{message}</Typography>
      )}
      {button && (
        <Box mt={3} mb={4} zIndex={1}>
          {button}
        </Box>
      )}
    </Box>
  );
};

export const NoItemsLoadingBody: React.VFC = () => {
  return (
    <NoItemsOverlayBody
      icon={<Loader mt={3} width="100px" height="100px" color="primary" />}
      message=""
    />
  );
};


export const NoItemsOverlay: React.VFC<OverlayProps> = ({ icon, message, subtitle, button }) => {
  const { classes } = useOverlayStyles();

  return (
    <GridOverlay className={classes.root}>
      <NoItemsOverlayBody icon={icon} message={message} subtitle={subtitle} button={button} />
    </GridOverlay>
  );
};



export const LoadingOverlay = () => {
  return (
    <GridOverlay>
      <CircularProgress style={{ zIndex: 1 }} />
    </GridOverlay>
  );
};
